import { ReactNode } from 'react'

export function renderParamValue(value: unknown): ReactNode {
  if (value === undefined || value === null) {
    return 'None'
  }

  if (typeof value === 'number') {
    return value
  }

  if (Array.isArray(value) || (value instanceof Object && value.constructor === Object)) {
    return JSON.stringify(value)
  }

  return value.toString()
}
